'use client';

import { useShallow } from 'zustand/react/shallow';
import { useGetCommonStore } from '@/store/commonStore';
import {
  type GamesListSource,
  selectGamesList,
} from '@/store/commonStore/selectors/selectGamesList';

export const useGamesList = (
  source: GamesListSource,
  param: string,
  subName?: string
) => {
  const useCommonStore = useGetCommonStore();

  return useCommonStore(useShallow(selectGamesList(source, param, subName)));
};
